import React, {Component} from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';

export default class ModalDeleteCoupleDecoration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            decorationModel: null,
            loading: false
        }

        this.deleteOrActiveCoupleDecoration = this.deleteOrActiveCoupleDecoration.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({
            decorationModel : props.decorationModel
        })
    }

    deleteOrActiveCoupleDecoration() {
        this.setState({
            loading: true
        });

        axios.post(global.config.apiDomain + '/rest/couple/deleteOrActiveCoupleDecoration', this.state.decorationModel)
        .then(res => {
            this.setState({
                loading: false
            });

            if (res.data.status == "OK") {
                window.$("#modalDeleteCoupleDecoration").modal("hide");
                toast.success(res.data.message); 
                this.props.resetList();
            } else {
                toast.warning(res.data.message);
            }
        })
    }

    render() {
        const {decorationModel} = this.state;

        return (
            <div>
                <div className="modal fade" id="modalDeleteCoupleDecoration" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                            {(decorationModel && !decorationModel.deleted) ? (
                                 <h5 className="modal-title" id="exampleModalLabel">XÓA Trang trí</h5>
                            ) : ""}
                            {(decorationModel && decorationModel.deleted) ? (
                                 <h5 className="modal-title" id="exampleModalLabel">HỦY XÓA Trang trí</h5>
                            ) : ""}
                               
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            {(decorationModel && !decorationModel.deleted) ? (
                                <div className="modal-body">
                                <h3 className="text-center text-danger">Bạn chắc chắn muốn XÓA Trang trí: <span className="font-weight-bold">Level {decorationModel._id}</span> ?</h3>
                            </div>
                            ) : ""}
                            {(decorationModel && decorationModel.deleted) ? (
                                <div className="modal-body">
                                <h3 className="text-center text-info">Bạn muốn HỦY XÓA Trang trí: <span className="font-weight-bold">Level {decorationModel._id}</span> ?</h3>
                            </div>
                            ) : ""}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ? 
                                (
                                <button style={{width: "120px"}} className="btn btn-red" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Xác nhận...
                                </button>
                                ) :
                                (
                                <button 
                                    style={{width: "120px"}} 
                                    type="button" 
                                    className="btn btn-red"
                                    onClick={this.deleteOrActiveCoupleDecoration}>Xác nhận</button>    
                                )}                        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}